export default class ToastService {
  constructor($log, $mdToast) {
    'ngInject';

    Object.assign(this, {
      $log,
      $mdToast
    });

    this.duration = 3000;
  }

  showError(error, message) {
    this.$log.error(error);

    this.$mdToast.show(
      this.$mdToast.simple()
        .textContent(message && message.length ? message : 'Error! Something went wrong!')
        .hideDelay(this.duration)
        .toastClass('error')
        .position('bottom right'));
  }

  showWarning(message) {
    this.$mdToast.show(
      this.$mdToast.simple()
        .textContent(message)
        .hideDelay(this.duration)
        .toastClass('error')
        .position('bottom right'));
  }

  showSuccess(message, opts) {
    this.$mdToast.show(
      this.$mdToast.simple()
        .textContent(message)
        .hideDelay(opts && opts.duration ? opts.duration : this.duration)
        .toastClass('success')
        .position('bottom right'));
  }
}



// WEBPACK FOOTER //
// ./services/toast.service.js